<template>
  <div class="row">
    <div
      v-for="item in items"
      :key="item.id"
      class="col-lg-4 col-md-6 wow move-up"
    >
      <div class="service-grid">
        <div class="ht-service-box--two text-center style-03">
          <router-link to="">
            <div class="image mb-20">
              <img
                :src="item.icon"
                class="img-fluid"
                alt="aeroland-startup-box-icon-01"
              />
            </div>
            <div class="content">
              <h6 class="heading">{{ item.heading }}</h6>
              <div class="service_text">{{ item.text }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StartUpFeatureTwo",
  data() {
    return {
      items: [
        {
          icon: require("../../assets/img/icons/aeroland-startup-box-icon-01.png"),
          heading: "網頁製作",
          text: "開發屬於您公司的網頁或網店，專屬UI/UX設計，支援各種支付平台，可訂製各樣專屬您業務特色的功能，並探索各種搜尋器優化（SEO）方案的可能性。網頁開發附有內容管理系統（CMS），讓您在後台輕鬆管理您的各種銷售收據。",
        },
        {
          icon: require("../../assets/img/icons/aeroland-startup-box-icon-02.png"),
          heading: "應用程式開發",
          text: "開發原生流動應用程式，讓您的客戶可以把您的應用程式下載到手機，與客戶拉近距離。本公司可協助您把應用程式上架到Apple Store及Google Play Store等大型應用程式下載平台。",
        },
        {
          icon: require("../../assets/img/icons/aeroland-startup-box-icon-05.png"),
          heading: "預約管理系統",
          text: "讓您的客人24小時自助預約服務，為您的預約排程及編排人員。可自訂電郵/SMS預約提示。讓您的預約更容易追蹤處理。",
        },
        {
          icon: require("../../assets/img/icons/aeroland-startup-box-icon-03.png"),
          heading: "庫存管理系統",
          text: "不論您有多少個倉庫、多少家分店，實時管理您的庫存。可支援條碼掃描出庫入庫，並管理貨品訊息。",
        },
        {
          icon: require("../../assets/img/icons/landing-feasture-image-06.png"),
          heading: "人力資源管理系統",
          text: "編更、請假、計糧，一個平台可以完成！可設置員工權限，編排工作，不論是小團隊還是大公司，公司人事工作編排盡在您掌握。",
        },
        {
          icon: require("../../assets/img/icons/aeroland-startup-box-icon-06.png"),
          heading: "物流管理系統",
          text: "可對接各大物流公司，也可用於管理自己物流團隊。實施更新送貨進度，庫存缺貨、訂單請求，都可一鍵發送。",
        },
      ],
    };
  },
};
</script>
